export default "__VITE_ASSET__DJ160cdA__"